import styled from 'styled-components';

interface IAnswer {
  isDesk: boolean;
}

const Container = styled.div<IAnswer>`
  display: grid;
  grid-template-columns: ${({ isDesk }) => (isDesk ? '48px auto' : '1fr 7fr')};
  padding: 16px 8px 16px 8px;
  font-size: 13px;
  word-break: break-word;
  background: #f4f4f4;
  position: relative;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;

const SvgAnswerBox = styled.div<IAnswer>`
  display: flex;
  justify-content: end;
  padding-right: 7px;
  padding-top: 4px;

  > svg {
    width: ${({ isDesk }) => (isDesk ? '16px' : '14px')};
    height: ${({ isDesk }) => (isDesk ? '16px' : '14px')};
  }
`;

const Answer = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  color: #575757;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
`;

const AnswerDesk = styled.span`
  font-style: normal;
  font-weight: 550;
  font-size: 14px;
  line-height: 16px;
  color: #6f6f6f;
`;

const AnswerOwner = styled.span`
  display: flex;
  margin: 7px 0 0px;
  font-style: normal;
  font-weight: 550;
  font-size: 12px;
  line-height: 14px;
  color: #6f6f6f;
`;

const AnswerCreatedAt = styled.span`
  font-style: normal;
  font-weight: 550;
  font-size: 12px;
  line-height: 14px;
  color: #6f6f6f;
`;

export { Answer, AnswerCreatedAt, AnswerOwner, AnswerDesk, SvgAnswerBox, Container, Wrapper };
